import { Status } from '@efexteam/components';
import { DueDateLabel } from '@pages/payables/types/dueDate.type';

export const DUE_DATE_STATUS: Record<DueDateLabel, Status> = {
  Add: 'positive',
  Bitso: 'generic',
  Completed: 'positive',
  Canceled: 'negative',
  Delivered: 'positive',
  Deposited: 'positive',
  Efex: 'generic',
  Missing: 'negative',
  Not_processed: 'warning',
  Pending_to_deposit: 'warning',
  Pending_to_process_scheduled_payment: 'special',
  Waiting_for_due_date: 'info',
  Pending_to_process: 'warning',
  Pending: 'warning',
  Processing: 'info',
  Rejected: 'negative',
  Expired: 'negative',
  Waiting_for_deposit: 'warning',
  Wallet_conversion: 'special',
  Wallet_transfer: 'special',
  Withdrawal: 'info',
  Deposit_failed: 'negative',
  Balance_discounted: 'info',
  Pending_to_approve: 'warning',
  Forward_pending: 'warning',
  Pending_to_processing: 'info',
  Waiting: 'warning',
  Pending_deposit: 'warning',
  Seen: 'info',
  Opened: 'info',
  Remove: 'info',
  Wallet: 'generic',
  Refunded: 'negative',
  New_payment_created: 'info',
  Regular: 'info',
  Validation_amount: 'info',
  Pending_to_approve_by_user: 'special',
};

export const getDueDateStatus = (status: DueDateLabel): Status =>
  DUE_DATE_STATUS[status];
